import request from './request';

//任务保存
export const saveTask = (data: object) => request(`${import.meta.env.VITE_API_PREFIX}/jenkins/cocos_encrypt`, 'POST_JSON', data);
//轮循接口
export const getTaskStatus = (data: object) => request(`${import.meta.env.VITE_API_PREFIX}/jenkins/cocos_encrypt`, 'GET', data);
